import { useReducer, useMemo, Dispatch } from 'react';

import { FlexDetails } from 'ggApp/types/graphql';

import useAction from '../../hooks/useAction';

import reducer, { SubscriptionDetailsCardStateType } from './reducer';
import {
    createSubscriptionDetailsCard as createSubscriptionDetailsCardAction,
    updateSubscriptionDetailsCard as updateSubscriptionDetailsCardAction,
    Action,
} from './actions';

function useActions(dispatch: Dispatch<Action>): SubscriptionDetailsCardActions {
    const createSubscriptionDetailsCard = useAction<FlexDetails, Action>(
        dispatch,
        createSubscriptionDetailsCardAction,
    );
    const updateSubscriptionDetailsCard = useAction<Partial<FlexDetails>, Action>(
        dispatch,
        updateSubscriptionDetailsCardAction,
    );

    const actions = useMemo(
        () => ({
            createSubscriptionDetailsCard,
            updateSubscriptionDetailsCard,
        }),
        [createSubscriptionDetailsCard, updateSubscriptionDetailsCard],
    );

    return actions;
}

function useDetailsCardState(): SubscriptionDetailsCardState {
    const [state, dispatch] = useReducer(reducer, null);
    const actions = useActions(dispatch);

    const subscriptionDetailsCardState = useMemo(
        () => ({
            detailsCard: state,
            actions,
        }),
        [state, actions],
    );

    return subscriptionDetailsCardState;
}

export default useDetailsCardState;

export interface SubscriptionDetailsCardActions {
    createSubscriptionDetailsCard: (param: FlexDetails) => void;
    updateSubscriptionDetailsCard: (param: Partial<FlexDetails>) => void;
}

export interface SubscriptionDetailsCardState {
    detailsCard: SubscriptionDetailsCardStateType;
    actions: SubscriptionDetailsCardActions;
}
